<template>
  <div id="app" :style="{ '--colorA': currentTheme.colorA, '--colorB': currentTheme.colorB }">
    <nav-header/>
    <router-view/>
    <csFooter/>
  </div>
</template>

<script>
import navHeader from './components/navHeader'
import csFooter from './components/footer.vue'

export default {
  name: 'app',
  components: {
    navHeader,
    csFooter
  },
  data: function() {
    return {
      currentTheme: {
        colorA: '#e63312',
        colorB: '#009f94'
      }
    }
  },
  computed: {
    theme() {
      return this.$store.getters['theme/getCurrentTheme']
    },
  },
  watch: {
    theme: function(theme) {
      if (theme) {
        this.currentTheme = theme;
      }
    }
  }
}
</script>

<style>
/*
red: var(--colorA)
blue: rgba(40, 70, 120, 0.9), var(--colorB)
*/

@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600,800|Roboto:900');

html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
html, body, *, *:after, *:before {
  box-sizing: border-box;
}
#app {
  position: relative;
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
a {
  text-decoration: none;
  color: var(--colorB);
  cursor: pointer;
}
h1 {
  font-family: 'Open Sans', sans-serif;
  font-weight: 800;
}
h2 {
  font-size: 28px;
}
p {
  font-size: 18px;
  line-height: 160%;
}
</style>
